/**
 * For a stack of avatars or thumbnails: up to `slots` items show; past that, one fewer, so a "+N"
 * for the rest takes the last slot.
 */
export function getStackItems<T>(
  items: T[],
  slots: number,
): { shownItems: T[]; moreCount: number } {
  if (items.length <= slots) {
    return { shownItems: items, moreCount: 0 };
  }
  const shownItems = items.slice(0, slots - 1);
  return { shownItems, moreCount: items.length - shownItems.length };
}
